import { AdvancedComponent } from './advanced.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SettingsService } from '../settings.service';
import { AdvancedRoutingModule } from './advanced-routing.module';

@NgModule({
  declarations: [AdvancedComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    DevEpressCommonModule,
    AdvancedRoutingModule,
    DxTextAreaModule,
    DxPopupModule
  ],
  providers: [SettingsService]
})
export class AdvancedModule { }